module.exports = __webpack_public_path__ + "img/hemingway_special.5d6140a5.jpg";